const WhatILearned = () => (
  <section id="education" className="bg-muted/50 py-20 sm:py-28">
    <div className="reading-column px-6">
      <h2 className="font-serif text-3xl text-foreground sm:text-4xl">What I learned</h2>

      <div className="mt-8 space-y-6 text-lg text-foreground/85">
        <p>
          The first thing I had to accept is that my body wasn't broken — it had simply changed.
          After 40, the way we hold weight, sleep, and recover is genuinely different. It's not
          a personal failure. It's a different chapter.
        </p>

        <p>And once I understood that, something softened in me.</p>

        <p>
          I learned that metabolism slows down quietly. That stress can hold on to weight in
          ways willpower can't undo. And that the strict, fast plans I kept reaching for were
          often the very things making me feel worse. The body I have now needs gentleness, not
          punishment.
        </p>
      </div>
    </div>
  </section>
);

export default WhatILearned;
